'use strict';

var isObject = require('./is-object');

/**
 * Verifica che il parametro in input sia un oggetto vuoto
 * @param mixed
 * @param checkOwnProperties
 * @returns {boolean}
 */
module.exports = function isEmptyObject(mixed, checkOwnProperties) {
    var i;

    if (!isObject(mixed)) {
        return false;
    }

    for (i in mixed) {
        if (checkOwnProperties || mixed.hasOwnProperty(i)) {
            return false;
        }
    }

    return true;
};
